import React from "react";

interface ErrorMessageProps {
  message: string;
}

export default function ErrorMessage({ message }: ErrorMessageProps) {
  return (
    <div className="d-flex flex-column align-items-center">
      <i className="bi bi-x-circle-fill error-icon"></i>
      <p className="m-3 fs-2 fw-semibold">{message}</p>
    </div>
  );
}
